<template>
    <v-row>
        <v-col>
            <v-row justify="center">
                <v-col class="text-center">
                    <v-btn icon target="_blank" href="https://twitter.com/daycohost">
                        <v-icon>mdi-twitter</v-icon>
                    </v-btn>
                    <v-btn icon target="_blank" href="https://www.instagram.com/daycohost/">
                        <v-icon>mdi-instagram</v-icon>
                    </v-btn>
                    <v-btn icon target="_blank" href="https://ve.linkedin.com/company/daycohost">
                        <v-icon>mdi-linkedin</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            <v-row no-gutters justify="center" class="text-center white--text">
                <div class="footer-info" v-bind:title="appMetadata">
                    &copy; {{ currentDate }}, Dayco Telecom, C.A.
                </div>
            </v-row>
        </v-col>
    </v-row>
</template>

<script type="ts">
import Vue from "vue";
import Component from "vue-class-component";

@Component({
    name: 'layout-footer'
})
export default class Footer extends Vue {
    currentDate = new Date().getFullYear();
    appMetadata = `Portal de Clientes Daycohost (v${process.env.VUE_APP_VERSION})`;
}
</script>

<style lang="scss" scoped>
.footer-info {
    font-size: 0.62rem !important;
    font-weight: 400;
    letter-spacing: 0.1666666667em !important;
    line-height: 1rem;
    text-transform: uppercase;
}
</style>
